import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 10.2738l-2.2929 2.2868V3h-2v9.5606l-2.29289-2.2868L7.3 11.6843l4.7071 4.6947 4.7071-4.6947L15.3 10.2738z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24248 13.4791l1.61548 1.6113c-.7705.1882-1.47213.4284-2.07831.7126-.68576.3214-1.19905.6776-1.50716 1.019-.2042.2264-.27249.3828-.27249.4903 0 .1076.06829.264.27249.4903.30811.3415.8214.6977 1.50716 1.0191 1.58124.7412 3.81203 1.1835 6.22035 1.1835 2.4083 0 4.6391-.4423 6.2203-1.1835.6858-.3214 1.1991-.6776 1.5072-1.0191.2042-.2263.2725-.3827.2725-.4903 0-.1075-.0683-.2639-.2725-.4903-.3081-.3414-.8214-.6976-1.5072-1.019-.606-.2841-1.3074-.5243-2.0776-.7125l1.6154-1.6112c2.566.8486 4.2419 2.2491 4.2419 3.833C22 19.9013 17.5228 22 12 22c-5.52285 0-10-2.0987-10-4.6877 0-1.5841 1.67618-2.9846 4.24248-3.8332z",
    fill: "currentColor"
  }));
});